import { TextProps as TextPropsAlias } from './Text';

export { Text } from './Text';

export type TextProps = TextPropsAlias;
